var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1337,
    height: 1409.002,
    viewBox: "0 0 1337 1409.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.315,961.702c-30.195-74.981-46.815-156.888-46.815-242.677C18.5,360.039,309.515,69.024,668.5,69.024c132.089,0,254.976,39.4,357.549,107.089",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.431,168.048c-6.152-54.329,27.072-125.614,58.934-168.048-2.912,88.731,12.271,180.235,55.754,259.405-85.965-25.839-178.515-15.348-265.304,3.659,38.951-41.592,92.758-86.871,150.616-95.017Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1267.42,466.015c32.892,77.765,51.08,163.263,51.08,253.009,0,358.985-291.015,650-650,650-147.911,0-284.283-49.404-393.515-132.611",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.033,1245.311c2.474,54.62-35.482,123.502-70.133,163.691,8.89-88.333-.088-180.653-38.133-262.575,84.027,31.578,177.074,27.352,264.947,14.241-41.667,38.87-98.406,80.418-156.681,84.643Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.4ad538db282a3d8356609c99b42193fd.svg";
export { ForwardRef as ReactComponent };